import {IPolicy, ISimpleEditPolicy, ISimpleVisiblePolicy} from "../PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import {IBusinessObject} from "../PA.Core.IF.BO";
import {IUsrContext} from "../PA.Core.IF.User";
import {PAEnvironment} from "../PAEnvironment";
import * as _ from 'lodash'
import {Subscription} from "rxjs/Subscription";
import {ILock, ILockOptions} from "../../PA.Concurrency.Core/PA.Concurrency.IF.Lock";

export class PolicyBOis
    implements IPolicy,
        ISimpleEditPolicy,
        ISimpleVisiblePolicy {
    _EditRoles: string[]
    _VisibleRoles: string[]
    _PolicyChanged: BehaviorSubject<IPolicy>
    _UserContext: IUsrContext
    _Editable: boolean
    _Visible: boolean
    _Wb_Cust_Id: number
    _onLockPropertyChanged: Subscription
    _Lock: ILock

    constructor(editRoles: string[], visibleRoles: string[], aWbCustomerId?: number, aLock?: ILock) {

        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._EditRoles = editRoles || []
        this._VisibleRoles = visibleRoles || []
        this._UserContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        this._Wb_Cust_Id = aWbCustomerId || 0

        this._Lock = aLock

        if (!_.isEmpty(aLock)) {
            this._onLockPropertyChanged = aLock.OnPropertyChanged.subscribe(x => this._PolicyChanged.next(this))
        }

        if (!this._UserContext) {
            return
        }

        let uc = this._UserContext

        this._Editable = false
        this._Visible = false
        _.forEach(this._EditRoles, (aRoleId) => {
            if (uc.hasRoleId(aRoleId, this._Wb_Cust_Id)) {
                this._Editable = true
                this._Visible = true
                return false
            }
        })

        if (!this._Editable) {
            _.forEach(this._VisibleRoles, (aRoleId) => {
                if (uc.hasRoleId(aRoleId, this._Wb_Cust_Id)) {
                    this._Visible = true
                    return false
                }
            })
        }

    }


    get Editable(): boolean {
        let bIsLockedAcquired = false
        if (_.isEmpty(this._Lock))
            bIsLockedAcquired = true
        else
            bIsLockedAcquired = (this._Lock.Status == "Locked")


        return this._Editable && bIsLockedAcquired
    }

    get Visible(): boolean {
        return this._Visible
    }


    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }


}